import { render } from "./EventPhotoAlbum.vue?vue&type=template&id=4446196c"
import script from "./EventPhotoAlbum.vue?vue&type=script&lang=js"
export * from "./EventPhotoAlbum.vue?vue&type=script&lang=js"

import "./EventPhotoAlbum.vue?vue&type=style&index=0&id=4446196c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__